import { Company } from "../../domain/entity/company";
import { UPDATE_STORE_COMPANY, UpdateStoreCompanyActionType } from "./actionType";

export const updateStoreCompany = (company: Company): UpdateStoreCompanyActionType => ({
    type   : UPDATE_STORE_COMPANY,
    payload: company
})
